/**
 * Arcade initials.
 *
 * Split out from the high score board because this is a pure rule about text
 * and that module reaches for `localStorage`. The global leaderboard's Lambda
 * needs this rule and must not drag a browser API into Node to get it.
 */

/** Arcade convention: exactly three characters, A-Z and 0-9. */
export const INITIALS_LENGTH = 3;
export const DEFAULT_INITIALS = 'AAA';

/** Coerces anything typed into a legal set of initials. */
export function normaliseInitials(raw: string): string {
  const cleaned = raw
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, '')
    .slice(0, INITIALS_LENGTH);
  return cleaned.padEnd(INITIALS_LENGTH, 'A');
}
